import { Text } from 'react-native'
import React from 'react'
import styles from '../../styles'

// eslint-disable-next-line import/prefer-default-export
export const createParagraphText = (t, translationKey, textStyle) => {
  const styleToUse = textStyle || styles.legalBodyContentText
  return (
    <Text style={styleToUse} testID={translationKey}>
      {t(translationKey)}
    </Text>
  )
}
